module.exports = __webpack_public_path__ + "assets/img/forgot-password-v2.d05cc586.svg";